import { render, staticRenderFns } from "./OsItemServico.vue?vue&type=template&id=75203771&scoped=true&"
import script from "./OsItemServico.vue?vue&type=script&lang=js&"
export * from "./OsItemServico.vue?vue&type=script&lang=js&"
import style0 from "./OsItemServico.vue?vue&type=style&index=0&id=75203771&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75203771",
  null
  
)

export default component.exports